export const SCRIPT_INTEGRATION_METHOD_BANNER_LOAD = "banner_load";
export const SCRIPT_INTEGRATION_METHOD_EDIT_CURRENT = "edit";
export const SCRIPT_INTEGRATION_METHOD_GTM_LOAD = "gtm_load";
export const SCRIPT_INTEGRATION_METHOD_AUTOBLOCK = "autoblock";
export const SCRIPT_INTEGRATION_METHOD_MANUAL = "manual";

export type ScriptIntegrationMethod = |
  typeof SCRIPT_INTEGRATION_METHOD_BANNER_LOAD |
  typeof SCRIPT_INTEGRATION_METHOD_EDIT_CURRENT |
  typeof SCRIPT_INTEGRATION_METHOD_GTM_LOAD |
  typeof SCRIPT_INTEGRATION_METHOD_AUTOBLOCK |
  typeof SCRIPT_INTEGRATION_METHOD_MANUAL;
